"use client";

import React from "react";
import { Activity, CircleCheck, FileText, ShieldCheck } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
const complianceData = [{
  id: "gistm",
  title: "GISTM",
  fullName: "Global Industry Standard on Tailings Management",
  description: "Rigorous adherence to GISTM protocols ensuring zero harm to people and the environment. Our methodology encompasses comprehensive risk assessments, emergency response planning, and transparent community engagement across all lifecycle phases.",
  milestone: "Implementation & Audit Readiness",
  progress: 98
}, {
  id: "icmm",
  title: "ICMM",
  fullName: "International Council on Mining & Metals Standards",
  description: "Alignment with ICMM's performance expectations for sustainable development. We integrate ethical business practices, integrate sustainable development considerations into corporate decision-making, and uphold fundamental human rights.",
  milestone: "Sustainability Integration",
  progress: 95
}, {
  id: "eor",
  title: "EOR",
  fullName: "Engineer of Record Oversight",
  description: "Providing continuous, authoritative technical oversight. Our EOR services provides reasonable assurance that tailings storage facilities are designed, constructed, operated, and decommissioned in accordance with the highest safety and engineering standards.",
  milestone: "Continuous Oversight Coverage",
  progress: 100
}, {
  id: "IRBR",
  title: "ITRB",
  fullName: "Independent Tailings Review Board",
  description: "Facilitating independent, third-party reviews by globally recognized experts. We coordinate ITRB activities to validate design parameters, operational practices, and risk mitigation strategies, ensuring objective technical assurance.",
  milestone: "Independent Review Cycles",
  progress: 90
}];
export default function CommitmentToGistmIcmmExcellence() {
  return <section id="commitment-to-gistm-icmm-excellence" className="bg-background w-full">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[80vh]">
        
        {}
        <div className="relative w-full min-h-[400px] lg:min-h-full bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618705/img/compliance_inspection_bw.png')] bg-cover bg-center grayscale contrast-125">
          {}
          <div className="absolute inset-0 bg-black/10"></div>
          <div className="absolute bottom-8 left-8 right-8 lg:bottom-12 lg:left-12">
            <div className="bg-background/90 backdrop-blur-sm p-6 border-l-4 border-primary inline-block">
              <p className="font-mono text-sm font-bold tracking-widest uppercase text-foreground flex items-center gap-2">
                <ShieldCheck className="size-5 text-primary" />
                Verified Compliance
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="dark bg-background text-foreground w-full flex flex-col justify-center p-8 md:p-12 lg:p-16 xl:p-24">
          <div className="max-w-xl">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-foreground">
              Excellence in Oversight
            </h2>
            <p className="text-muted-foreground mb-10 font-sans leading-relaxed">Our commitment to global standards is uncompromising. We implement transformative programs that align with the most stringent global frameworks for tailings management and geotechnical safety.</p>

            <Tabs defaultValue="gistm" className="w-full">
              <TabsList className="w-full grid grid-cols-4 mb-8 bg-muted/50 p-1 rounded-lg">
                {complianceData.map((tab, i) => <TabsTrigger key={tab.id} value={tab.id} data-index={i} className="font-mono text-xs sm:text-sm uppercase tracking-wider">
                    {tab.title}
                  </TabsTrigger>)}
              </TabsList>

              {complianceData.map((tab, i) => <TabsContent key={tab.id} value={tab.id} data-index={i} className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
                  <div className="space-y-4">
                    <h3 className="text-xl sm:text-2xl font-semibold text-primary flex items-center gap-3">
                      <FileText className="size-6 opacity-80" />
                      {tab.fullName}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {tab.description}
                    </p>
                  </div>

                  <div className="bg-muted/30 border border-border/50 rounded-lg p-6 space-y-4">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                      <span className="font-mono text-sm text-foreground flex items-center gap-2">
                        <Activity className="size-4 text-primary" />
                        Milestone: {tab.milestone}
                      </span>
                      <span className="font-mono text-sm font-bold text-primary">
                        {tab.progress}%
                      </span>
                    </div>
                    <Progress value={tab.progress} className="h-1.5 bg-muted" />
                  </div>
                </TabsContent>)}
            </Tabs>

            <div className="mt-12 pt-8 border-t border-border/50">
              <Button variant="outline" className="font-mono uppercase tracking-wider text-xs w-full sm:w-auto">
                <CircleCheck className="size-4 mr-2" />
                Request Compliance Report
              </Button>
            </div>
          </div>
        </div>

      </div>
    </section>;
}